require("../layout");
require("slick-carousel");
require("@fancyapps/fancybox");


$("#welcome").find('.slide-welcome').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
})

$("#important-items").find('.slide-images').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".slick-count .big").text("0" + i);
    $(".slick-count .small").text("/0" + slick.slideCount);
}).slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,

}).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var id = $(this)
        .find(".slick-current")
        .find(".item")
        .data("id");

    $(`.slide-content .item`).removeClass('active');
    $(`#${id}`).addClass('active');
});

$("#important-items").find('.slide-content').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
})

$("#models").find('.slide-info-modelo').slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('#models').find('.prev'),
    nextArrow: $('#models').find('.next'),
    fade: true,
}).on('afterChange', function (event, slick, currentSlide) {
    var dataImage = $(slick.$slides[currentSlide]).find(".item").data("image");
    $(".item-images-model").removeClass("show");
    $(dataImage).addClass("show");
})

var initImage = $("#models").find('.slide-info-modelo').find(".slick-active").find(".item").data("image");
$(initImage).addClass("show");

$('#select-depto').on('change', function () {
    $("#models").find('.slide-info-modelo').slick("slickUnfilter");

    filterSlide()
})

function filterSlide() {
    let val = $('#select-depto').val();

    if (val == "all") {
        $("#models").find('.slide-info-modelo').slick("slickFilter", function () {
            return $(this).find('.item').attr("data-all") == val;
        });
    } else {
        $("#models").find('.slide-info-modelo').slick("slickFilter", function () {
            return $(this).find('.item').attr("data-id") == val;
        });
    }
    $(".item-images-model").removeClass("show");
    var initImage = $("#models").find('.slide-info-modelo').find(".slick-active").find(".item").data("image");
    $(initImage).addClass("show");
    console.log(initImage)
}

function initializeSlick(selector) {
    $(selector).slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1500, // Ajusta este valor según tu diseño
                settings: {
                    slidesToShow: 2, // Muestra solo 2 imágenes en pantallas más pequeñas de escritorio
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}


/*initializeSlick("#intern-gallery-depto1");
initializeSlick("#exterior-gallery-exterior");

$(".btn-change-gallery").on("click", function () {
    var galleryID = $(this).data('id');
    $(".btn-change-gallery").removeClass("active");
    $(this).addClass("active");

    $("#intern-gallery .slide").hide();

    $(galleryID).show();

    $("#intern-gallery .slide").each(function () {
        if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }
    });

    setTimeout(function () {
        initializeSlick(galleryID);
    }, 0);
});*/

// Inicializa todas las galerías activas al cargar
function initializeAllGalleries() {
    // Validar si existen galerías interiores
    if ($('#intern-gallery').length && $('#intern-gallery .slide.active').length) {
        $('#intern-gallery .slide.active').each(function() {
            initializeSlick(`#${$(this).attr('id')}`);
        });
    }

    // Validar si existen galerías exteriores
    if ($('#exterior-gallery').length && $('#exterior-gallery .slide.active').length) {
        $('#exterior-gallery .slide.active').each(function() {
            initializeSlick(`#${$(this).attr('id')}`);
        });
    }
}

// Llamar al inicializar
initializeAllGalleries();

// Event handler para cambiar entre tabs
$(".btn-change-gallery").on("click", function () {
    var galleryID = $(this).data('id');
    var $parentSection = $(this).closest('section');

    // Validar que la sección padre exista
    if (!$parentSection.length) return;

    var parentSectionID = $parentSection.attr('id');

    // Remueve active solo de los botones de esta sección
    $(`#${parentSectionID} .btn-change-gallery`).removeClass("active");
    $(this).addClass("active");

    // Oculta y destruye slick solo en los slides de esta sección
    $(`#${parentSectionID} .slide`).hide().each(function () {
        if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }
    });

    // Validar que el slide objetivo exista antes de mostrarlo
    if ($(galleryID).length) {
        $(galleryID).show();

        setTimeout(function () {
            initializeSlick(galleryID);
        }, 0);
    }
});

require("../componentes/recorrido_virtual");
require("../componentes/botones_flotantes");
require("../componentes/proyecto/modal_promotion");
